import React, { useEffect, useState, forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import { CircularProgress, Paper } from '@material-ui/core'
import { useVestigioService } from 'hooks/useVestigioService'
import useRouter from 'utils/useRouter'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import MaterialTable from 'material-table'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { setIdVestigio } from 'actions'
import useStyles from './styles'

export const UltimosVestigiosEncaminhados = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const router = useRouter()
  const vestigioService = useVestigioService()
  moment.locale('pt-br', localization)
  const [vestigios, setVestigios] = useState([])
  const [processandoVestigios, setProcessandoVestigios] = useState(false)

  useEffect(() => {
    const fetchVestigiosEncaminhados = async () => {
      const response = await vestigioService.listarVestigiosEncaminhadosParaSetoresDoUsuarioAsync(setProcessandoVestigios)
      setVestigios(response)
    }

    fetchVestigiosEncaminhados()
  }, [])

  const handleRowClick = (rowData) => {
    router.history.push(`/casos/caso/vestigio/detalhar/${id}`)
  }

  const getNomeSetorCortado = (setor) => `${setor.substring(0, 30)}...`

  return (
    <div>
      {processandoVestigios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div className={classes.chart}>
          <MaterialTable
            components={{ Container: (props) => <Paper {...props} elevation={0} /> }}
            localization={{
              body: {
                emptyDataSourceMessage: processandoVestigios ? <CircularProgress disableShrink /> : 'Nenhum exame encontrado',
                filterRow: {
                  filterTooltip: 'Filtro',
                },
              },
              header: {
                actions: 'Ações',
              },
            }}
            title=""
            columns={[
              {
                title: 'identificador',
                render: (rowData) => rowData.identificador,
              },

              {
                title: 'tipo',
                render: (rowData) => (rowData.tipoVest ? rowData.tipoVest.nome : '-'),
              },

              {
                title: 'Setor',
                render: (rowData) => (rowData.setDest && rowData.setDest.id ? getNomeSetorCortado(rowData.setDest.nome) : '-'),
              },
            ]}
            onRowClick={(event, rowData) => handleRowClick(rowData)}
            data={vestigios}
            options={{
              actionsColumnIndex: -1,
              search: false,
              pageSize: 4,
              pageSizeOptions: ['4'],
              headerStyle: {
                backgroundColor: '#f4f6f8',
              },
              toolbar: false,
            }}
            icons={{
              SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
              Search: forwardRef((propsSearch, ref) => <SearchIcon {...propsSearch} ref={ref} />),
              ResetSearch: forwardRef((propsResetSearch, ref) => <ClearIcon {...propsResetSearch} ref={ref} />),
              NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
              DetailPanel: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
              PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
              FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
              LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
            }}
            style={{
              padding: '10px',
              fontSize: '12px',
              textAlign: 'left',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: '400',
              lineHeight: '10px',
              letterSpacing: '-0.05px',
              verticalAlign: 'inherit',
            }}
          />
        </div>
      )}
    </div>
  )
}
